<span class="alert-message" matSnackBarLabel>
	{{ data.message }}
</span>
<span matSnackBarActions>
	<button
		mat-button
		matSnackBarAction
		(click)="snackBarRef.dismissWithAction()"
	>
		@if (data.icon) {
			<mat-icon class="icon">{{ data.icon }}</mat-icon>
		} @else {
			<span class="action-btn">{{ data.action }} </span>
		}
	</button>
</span>
